module.exports = __webpack_public_path__ + "img/overcast.a164ff5e.png";